export var buildSnowplowLabel = function (args) {
    return JSON.stringify(args);
};
export var filterEvents = function (element) {
    // if a component has no data-sp-button-label then ignore
    return !!element.dataset.spButtonLabel;
};
